import { SessionLayer } from "../../interfaces";
import { getAppBFFUrl } from "../functions";
import { formatData, handleError, handleStepSuccessEvent } from "./api";

export const sendMedicalQuestionnaire = async (data: SessionLayer, requestConditions: any) => {
  const { lead_data, push_data, marketing_data } = data;
  const { is_last_step, hasSuccessStep, defaultSuccessPageUrl, successPageRules } = requestConditions;
  
  const formattedData = await formatData(lead_data, push_data, marketing_data, is_last_step, true);
  const baseUrl = await getAppBFFUrl();

  const requestBody = new FormData();
  const leadDataObject: any = {};
  const medical_history: { [key: string]: FormDataEntryValue } = {};
  const questionnaire_data: { [key: string]: FormDataEntryValue } = {};

  formattedData.forEach((value: FormDataEntryValue, key: string) => {

    if (key.startsWith('medical_history_')) {
      medical_history[key] = value;
    } else if (key.startsWith('iief_')) {
      questionnaire_data[key] = value;
    } else {
      requestBody.append(key, value);
      leadDataObject[key] = value;
    }
  });

  if (Object.keys(medical_history).length) {
    requestBody.append('medical_history', JSON.stringify(medical_history));
    leadDataObject.medical_history = medical_history;
  }
  if (Object.keys(questionnaire_data).length) {
    requestBody.append('questionnaire_data', JSON.stringify(questionnaire_data));
    leadDataObject.questionnaire_data = questionnaire_data;
  }

  if (is_last_step) {
    // extract all fields that begin with "medical_history_" and add them as a json object to leadDataObject.medical_history
    const medicalHistoryFields = Object.keys(leadDataObject).filter((key) => key.startsWith('medical_history_'));
    leadDataObject.medical_history = medicalHistoryFields;
    // extract all fields that begin with "iief_" and add them as a json object to leadDataObject.questionnaire_data
    const iiefFields = Object.keys(leadDataObject).filter((key) => key.startsWith('iief_'));
    leadDataObject.questionnaire_data = iiefFields;
  }

  try {
    const res = await fetch(
      `${baseUrl}/platform-nexus/public/v2/medical-questionnaires/`,
      {
        method: 'POST',
        body: requestBody,
      },
    );
    await handleStepSuccessEvent(res, is_last_step, hasSuccessStep, defaultSuccessPageUrl, successPageRules);

    const responseData = await res.json();

    return {res, details: responseData?.detail}
  } catch (error) {
    handleError(error);
  }
}